import React from 'react'
import { NextPage } from 'next'
import PublicLayout from 'src/components/Layout/public'
import { Section } from 'src/components/Common/Section'
import { colors } from 'src/theme/colors'
import { useRouter } from 'next/router'
import { Title } from 'src/components/Common'
import { useTranslation } from 'react-i18next'
import { CategoryContainer } from 'src/components/Curso/styles'
import TitleWrapper from 'src/components/Common/TitleWrapper'
import { CategoryExtendedApi } from 'src/service/api/api.types'
import { apiPrivate } from 'src/service/api/api.private'
import { useDispatch } from 'react-redux'
import { setIdCategory } from 'src/store/category'
import Container from 'src/components/Common/Container'
import { GridSkeleton } from 'src/components/Skeleton/grid'
import { GridWrapper } from 'src/components/Grid/styles'
import { ModuleCard } from 'src/components/Common/ModuleCard'
import { getImageUrl } from 'src/utils/getImageUrl'

export type InfoModule = { title: string; course: string; imageUrl: string }

const Course: NextPage = () => {
  const router = useRouter()
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const params = router.query as InfoModule
  const [category, setCategory] = React.useState<CategoryExtendedApi>()
  const [isLoading, setIsLoading] = React.useState(false)

  React.useEffect(() => {
    if (params.course) {
      ;(async () => {
        await fetchCategory()
      })()
    }
  }, [params.course])

  async function fetchCategory() {
    setIsLoading(true)
    const res = await apiPrivate.getCategoryExtended(params.course)
    if (res.kind === 'ok') {
      setCategory(res.data)
      dispatch(setIdCategory(params.course))
    }
    setIsLoading(false)
  }

  function RenderModules() {
    if (category && category?.modules?.length > 0) {
      return (
        <GridWrapper>
          {category.modules.map(item => (
            <ModuleCard
              link={`/curso/${category.slug}/${item.slug}`}
              imageUrl={item?.imageUrl ? getImageUrl(item.imageUrl, 277, 150) : category.iconUrl}
              key={item.id}
              isIcon={item?.imageUrl === null}
              className="card-grid"
              data={item}
            />
          ))}
        </GridWrapper>
      )
    }

    return <></>
  }

  return (
    <PublicLayout showCategory={false}>
      <CategoryContainer>
        <TitleWrapper>
          <Title
            borderMargin="medium"
            size="lg"
            borderColor={colors.palette.white}
            tx={category?.title || ''}
            iconSource={category?.iconUrl}
            hasIcon
            hasBorder
            theme="light"
          />
          <small>{t('category.text')}</small>
        </TitleWrapper>
        <Section preset="courses" padding="1rem 0" paddingMobile="1rem 0">
          <Container>{isLoading ? <GridSkeleton /> : <RenderModules />}</Container>
        </Section>
      </CategoryContainer>
    </PublicLayout>
  )
}

export default Course
